import {
  getDropperMaker,
  getItemMaker,
  getRecipeMaker,
  getSinkMaker,
  mkIQ as n,
  mkPercentageDrop as pd,
} from "./tools";

const i = getItemMaker("alchemy liquids");
export const alchemyLiquids = [
  i("Water Droplets"),
  i("Liquid Nitrogen"),
  i("Trench Seawater"),
  i("Toxic Mercury"),
];

export const alchemyProduction = [
  "Water Droplets",
  "Liquid Nitrogen",
  "Trench Seawater",
  "Toxic Mercury",
];

const water = n("Water Droplets", NaN);
const nitrogen = n("Liquid Nitrogen", NaN);
const seawater = n("Trench Seawater", NaN);
const mercury = n("Toxic Murcury", NaN);

const shop = getSinkMaker("alchemy shop");
const bubble = getSinkMaker("alchemy bubble");
const vial = getSinkMaker("alchemy vial");
export const alchemySinks = [
  shop("Mediocre Obols", water),
  shop("Weak UPG Stone", water),
  shop("Decent Obols", water, nitrogen),
  shop("Grand Obols", nitrogen, seawater),
  shop("Bargain Tag", nitrogen, seawater),

  bubble("Roid Ragin", n("Oak Logs", NaN), water),
  bubble("Warriors Rule", n("Spore Cap", NaN), water),
  bubble("Hearty Diggy", n("Jungle Logs", NaN), water),
  bubble("Wyoming Blood", n("Fly", NaN), water),
  bubble("Reely Smart", n("Boring Brick", NaN), water),
  bubble("Big Meaty Claws", n("Furled Flag", NaN), water),
  bubble("Sploosh Sploosh", n("Hermit Can", NaN), water),
  bubble("Stronk Tools", n("Platinum Ore", NaN), water),
  bubble("FMJ", n("Fruitfly", NaN), water),
  bubble("Bappity Boopity", n("Pinion Spur", NaN), water),
  bubble("Brittley Spears", n("Froge", NaN), nitrogen),
  bubble("Call me Bob", n("Moustache Comb", NaN), nitrogen),
  bubble("Carpenter", n("Explosive Salts", NaN), nitrogen),
  bubble("Buff Boi Talent", n("Mousey", NaN), nitrogen),
  bubble("Orange Bargain", n("Frigid Soul", NaN), nitrogen),
  bubble("Penny of Strength", n("Skelefish", NaN), seawater),
  bubble("Multorange", n("Half Eaten Donut", NaN), seawater),
  bubble("Dream of Ironfish", n("Tangled Cords", NaN), seawater),
  bubble("Shimmeron", n("PVC Pipe", NaN), seawater),
  bubble("Bite but not Chew", n("Condensed Zap", NaN), seawater),
  bubble("Spear Powah", n("Bits", NaN), seawater),
  bubble("Slabi Orefish", n("Oozie Soul", NaN), seawater),
  bubble("Gamer at Heart", n("Sailing Treasure 9", NaN), seawater),
  bubble("Slabi Strength", n("OJ Juice", NaN), seawater),
  bubble("Power Trione", n("Sailing Treasure 20", NaN), seawater),
  bubble("Farquad Force", n("Farm Item 1", NaN), seawater),
  bubble("Endgame Eff I", n("Stacked Rice Cake", NaN), seawater),
  bubble("Tome Strength", n("Summoning Item 3", NaN), mercury),
  bubble("Essence Boost", n("Effervescent Logs", NaN), mercury),
  bubble("Crop Chapter", n("Summoning Item 5", NaN), mercury),

  bubble("Swift Steppin", n("Copper Ore", NaN), water),
  bubble("Archer Or Bust", n("Spore Cap", NaN), water),
  bubble("Hammer Hammer", n("Iron Ore", NaN), water),
  bubble("Lil Big Damage", n("Goldfish", NaN), water),
  bubble("Anvilnomics", n("Forest Fibres", NaN), water),
  bubble("Quick Slap", n("Coconotnotto", NaN), water),
  bubble("Sanic Tools", n("Slime Sludge", NaN), water),
  bubble("Bug²", n("Sentient Cereal", NaN), water),
  bubble("Shaquracy", n("Bloach", NaN), water),
  bubble("Cheap Shot", n("Mosquisnow", NaN), water),
  bubble("Bow Jack", n("Forest Soul", NaN), nitrogen),
  bubble("Call Me Ash", n("Tundra Logs", NaN), nitrogen),
  bubble("Cuz I Catch Em All", n("Rooted Soul", NaN), nitrogen),
  bubble("Fast Boi Talent", n("Flycicle", NaN), nitrogen),
  bubble("Green Bargain", n("Owlio", NaN), nitrogen),
  bubble("Dollar Of Agility", n("Purple Screw", NaN), seawater),
  bubble("Premigreen", n("Dung Beat", NaN), seawater),
  bubble("Fly In Mind", n("Worker Bee", NaN), seawater),
  bubble("Kill Per Kill", n("Dioxide Synthesis", NaN), seawater),
  bubble("Afk Expexp", n("Fairy", NaN), seawater),
  bubble("Bow Power", n("Bits", NaN), seawater),
  bubble("Slabo Critterbug", n("Maple Logs", NaN), seawater),
  bubble("Sailor At Heart", n("Sailing Treasure 11", NaN), seawater),
  bubble("Slabo Agility", n("Hard Hat", NaN), seawater),
  bubble("Power Tritwo", n("Sailing Treasure 24", NaN), seawater),
  bubble("Quickdraw Quiver", n("Jade Coin", NaN), seawater),
  bubble("Essence Boost", n("Bamboo Logs", NaN), seawater),
  bubble("Endgame Eff II", n("Farm Item 3", NaN), mercury),
  bubble("Tome Agility", n("Firefly", NaN), mercury),
  bubble("Stealth Chapter", n("Farm Item 5", NaN), mercury),

  bubble("Stable Jenius", n("Bleach Logs", NaN), water),
  bubble("Mage Is Best", n("Spore Cap", NaN), water),
  bubble("Hocus Choppus", n("Trusty Nails", NaN), water),
  bubble("Molto Loggo", n("Iron Bar", NaN), water),
  bubble("Noodubble", n("Chain Link", NaN), water),
  bubble("Name I Guess", n("Gold Ore", NaN), water),
  bubble("Le Brain Tools", n("Sentient Cereal", NaN), water),
  bubble("Cookin Roadkill", n("Potty Rolls", NaN), water),
  bubble("Brewstachio", n("High Steaks", NaN), water),
  bubble("All For Kill", n("Veiny Logs", NaN), water),
  bubble("Matty Stafford", n("Redox Salts", NaN), nitrogen),
  bubble("Call Me Pope", n("Crabbo", NaN), nitrogen),
  bubble("Gospel Leader", n("Mosquisnow", NaN)),
  bubble("Smart Boi Talent", n("Sippy Straw", NaN), nitrogen),
  bubble("Purple Bargain", n("Forest Soul", NaN), nitrogen),
  bubble("Nickel Of Wisdom", n("Alien Hive Chunk", NaN), seawater),
  bubble("Severapurple", n("Void Ore", NaN), seawater),
  bubble("Tree Sleeper", n("Squishy Soul", NaN), seawater),
  bubble("Hyperswift", n("Manta Ray", NaN), seawater),
  bubble("Matrix Evolved", n("Cubed Logs", NaN), seawater),
  bubble("Wand Pawur", n("Bits", NaN), seawater),
  bubble("Slabe Logsoul", n("Scarab", NaN), seawater),
  bubble("Pious At Heart", n("Sailing Treasure 13", NaN), seawater),
  bubble("Slabe Wisdom", n("Wormie Slices", NaN), seawater),
  bubble("Power Trithree", n("Sailing Treasure 28", NaN), seawater),
  bubble("Smarter Spells", n("Summoning Item 1", NaN), seawater),
  bubble("Endgame Eff Ili", n("Summoning Item 2", NaN), seawater),
  bubble("Essence Boost", n("Breezy Soul", NaN), mercury),
  bubble("Tome Wisdom", n("Farm Item 4", NaN), mercury),
  bubble("Essence Chapter", n("Jade Coin", NaN), mercury),

  bubble("Lotto Skills", n("Thread", NaN), water),
  bubble("Droppin Loads", n("Goldfish", NaN), water),
  bubble("Startue Exp", n("Pocket Sand", NaN), water),
  bubble("Level Up Gift", n("Crabby Cakey", NaN), water),
  bubble("Prowesessary", n("Potty Rolls", NaN), water),
  bubble("Stamp Tramp", n("Butterfly", NaN), water),
  bubble("Undeveloped Costs", n("Jellyfish", NaN), water),
  bubble("Da Daily Drip", n("Leather Hide", NaN), water),
  bubble("Grind Time", water, nitrogen),
  bubble("Laaarrrryyyy", n("Dementia Ore", NaN), nitrogen),
  bubble("Cogs For Hands", n("Melty Cube", NaN), nitrogen),
  bubble("Sample It", n("Dune Soul", NaN), nitrogen),
  bubble("Big Game Hunter", n("Scorpie", NaN), nitrogen),
  bubble("Ignore Overdues", n("Wispy Lumber", NaN), nitrogen),
  bubble("Yellow Bargain", n("Pingy", NaN), nitrogen),
  bubble("Mr Massacre", n("Spontaneity Salts", NaN), seawater),
  bubble("Egg Ink", seawater),
  bubble("Diamond Chef", seawater),
  bubble("Card Champ", seawater),
  bubble("Petting The Rift", n("Blobfish", NaN), seawater),
  bubble("Boaty Bubble", n("Bits", NaN), seawater),
  bubble("Big P", n("Sailing Treasure 1", NaN), seawater),
  bubble("Bit By Bit", n("Dandielogs", NaN), seawater),
  bubble("Gifts Abound", n("Dust Mote", NaN), seawater),
  bubble("Atom Split", n("Mongo Worm Slices", NaN), seawater),
  bubble("Croppius Mapper", n("Wooden Aortic Mass", NaN), seawater),
  bubble("Essence Boost", n("Ladybug", NaN), seawater),
  bubble("Hinge Buster", n("Farm Item 2", NaN), seawater),
  bubble("Ninja Looter", n("Summoning Item 4", NaN), mercury),
  bubble("Lo Cost Mo Jade", n("Royal Yolk", NaN), mercury),

  vial("Copper Corona", n("Copper Ore", NaN), water),
  vial("Sippy Splinters", n("Oak Logs", NaN), water),
  vial("Mushroom Soup", n("Spore Cap", NaN), water),
  vial("Spool Sprite", n("Thread", NaN), water),
  vial("Barium Mixture", n("Copper Bar", NaN), water),
  vial("Dieter Drink", n("Bean Slices", NaN), water),
  vial("Skinny 0 Cal", n("Snake Skin", NaN), water),
  vial("Thumb Pow", n("Trusty Nails", NaN), water),
  vial("Jungle Juice", n("Jungle Logs", NaN), water),
  vial("Barley Brew", n("Iron Bar", NaN), water),
  vial("Anearful", n("Glublin Ear", NaN), water),
  vial("Tea With Pea", n("Potty Rolls", NaN), water),
  vial("Gold Guzzle", n("Gold Ore", NaN), water),
  vial("Ramificoction", n("Bullfrog Horn", NaN), water),
  vial("Seawater", n("Goldfish", NaN), water),
  vial("Tail Time", n("Rats Tail", NaN), water),
  vial("Fly In My Drink", n("Fly", NaN), water),
  vial("Mimicraught", n("Megalodon Tooth", NaN), water),
  vial("Blue Flav", n("Platinum Ore", NaN), water),
  vial("Slug Slurp", n("Hermit Can", NaN), water),
  vial("Pickle Jar", n("BobJoePickle", NaN), nitrogen),
  vial("Fur Refresher", n("Floof Ploof", NaN), nitrogen),
  vial("Sippy Soul", n("Forest Soul", NaN), nitrogen),
  vial("Crab Juice", n("Crabbo", NaN), nitrogen),
  vial("Void Vial", n("Void Ore", NaN), nitrogen),
  vial("Red Malt", n("Redox Salts", NaN), nitrogen),
  vial("Ew Gross Gross", n("Mosquisnow", NaN), nitrogen),
  vial("The Spanish Sahara", n("Tundra Logs", NaN), nitrogen),
  vial("Poison Tincture", n("Poison Froge", NaN), nitrogen),
  vial("Etruscan Lager", n("Mamooth Tusk", NaN), nitrogen),
  vial("Chonker Chug", n("Dune Soul", NaN), nitrogen),
  vial("Bubonic Burp", n("Mousey", NaN), seawater),
  vial("Visible Ink", n("Pen", NaN), seawater),
  vial("Orange Malt", n("Explosive Salts", NaN), seawater),
  vial("Snow Slurry", n("Snow Ball", NaN), seawater),
  vial("Slowergy Drink", n("Frigid Soul", NaN), seawater),
  vial("Sippy Cup", n("Sippy Straw", NaN), seawater),
  vial("Bunny Brew", n("Bunny", NaN), seawater),
  vial("40-40 Purity", n("Contact Lense", NaN), seawater),
  vial("Shaved Ice", n("Purple Salt", NaN), seawater),
  vial("Goosey Glug", n("Honker", NaN), seawater),
  vial("Ball Pickle Jar", n("BallJoePickle", NaN), seawater),
  vial("Capachino", n("Purple Mush Cap", NaN), seawater),
  vial("Donut Drink", n("Half Eaten Donut", NaN), seawater),
  vial("Long Island Tea", n("Sand Shark", NaN), seawater),
  vial("Spook Pint", n("Squishy Soul", NaN), seawater),
  vial("Calcium Carbonate", n("Tongue Bone", NaN), seawater),
  vial("Bloat Draft", n("Blobfish", NaN), seawater),
  vial("Choco Milkshake", n("Crumpled Wrapper", NaN), seawater),
  vial("Pearl Seltzer", n("Pearler Shell", NaN), seawater),
  vial("Krakenade", n("Kraken", NaN), seawater),
  vial("Electrolyte", n("Condensed Zap", NaN), seawater),
  vial("Ash Agua", n("Suggma Ashes", NaN), seawater),
  vial("Maple Syrup", n("Maple Logs", NaN), seawater),
  vial("Hampter Drippy", n("Hampter", NaN), seawater),
  vial("Dreadnog", n("Dreadlo Bar", NaN), seawater),
  vial("Dusted Drink", n("Dust Mote", NaN), seawater),
  vial("Oj Jooce", n("Orange Slice", NaN), seawater),
  vial("Oozie Ooblek", n("Oozie Soul", NaN), seawater),
  vial("Venison Malt", n("Mongo Worm Slices", NaN), seawater),
  vial("Marble Mocha", n("Marble Ore", NaN), seawater),
  vial("Willow Sippy", n("Willow Logs", NaN), seawater),
  vial("Shinyfin Stew", n("Equinox Fish", NaN), seawater),
  vial("Dreamy Drink", n("Dream Particulate", NaN), seawater),
  vial("Ricecakorade", n("Rice Cake", NaN), mercury),
  vial("Ladybug Serum", n("Ladybug", NaN), mercury),
  vial("Flavorgil", n("Caulifish", NaN), mercury),
  vial("Greenleaf Tea", n("Leafy Branch", NaN), mercury),
  vial("Firefly Grog", n("Firefly", NaN), mercury),
  vial("Dabar Special", n("Godshard Bar", NaN), mercury),
  vial("Refreshment", n("Breezy Soul", NaN), mercury),
  vial("Gibbed Drink", n("Eviscerated Chunk", NaN), mercury),
  vial("Ded Sap", n("Effervescent Logs", NaN), mercury),
  vial("Royale Cola", n("Royal Headpiece", NaN), mercury),
  vial("Turtle Tisane", n("Tuttle", NaN), mercury),
];

const r = getRecipeMaker("alchemy");
export const alchemyRecipes = [
  r("Distilled Water", water),
  r("Gem", water),
  r("Tick Tock (Special Talent Book)", water),
  r("Small Experience Balloon", water),
  r("Talent Point Tab 2", water, nitrogen),
  r("Dense Water", seawater),
  r("Gem", seawater),
  r("Talent Point Tab 3", seawater),
];

const d = getDropperMaker("alchemy shop");
export const alchemyDroppers = [
  d(
    "Mediocre Obols",
    "YumYum Grotto",
    pd("Bronze STR Obol", 18),
    pd("Bronze AGI Obol", 18),
    pd("Bronze WIS Obol", 18),
    pd("Bronze LUK Obol", 18),
    pd("Bronze Obol of Small Swings", 10),
    pd("Bronze Obol of Chippin Chops", 17),
    pd("Bronze Obol of Puny Damage", 7),
    pd("Bronze Obol of Cards", 2),
  ),
  d(
    "Decent Obols",
    "YumYum Grotto",
    pd("Bronze STR Obol", 11),
    pd("Bronze AGI Obol", 11),
    pd("Bronze WIS Obol", 11),
    pd("Bronze LUK Obol", 6),
    pd("Bronze Obol of Finite Fish", 11),
    pd("Bronze Obol of Few Flies", 11),
    pd("Bronze Obol of Puny Damage", 7),
    pd("Silver STR Obol", 4),
    pd("Silver AGI Obol", 4),
    pd("Silver WIS Obol", 4),
    pd("Silver LUK Obol", 1),
    pd("Silver Obol of Moderate Mining", 4),
    pd("Silver Obol of Big Bark", 4),
    pd("Silver Obol of Puny Pikes", 4),
    pd("Silver Obol of Big Bugs", 3),
    pd("Silver Obol of Little Damage", 2),
    pd("Silver Obol of Cards", 2),
  ),
  d(
    "Grand Obols",
    "YumYum Grotto",
    pd("Bronze STR Obol", 11),
    pd("Bronze AGI Obol", 11),
    pd("Bronze WIS Obol", 11),
    pd("Bronze Obol of Trapping", 4),
    pd("Bronze Obol of Construction", 6),
    pd("Bronze Obol of Worship", 4),
    pd("Bronze Obol of Multikill", 11),
    pd("Bronze Obol of Defence", 11),
    pd("Silver STR Obol", 4),
    pd("Silver AGI Obol", 4),
    pd("Silver WIS Obol", 4),
    pd("Silver Obol of Trapping", 3),
    pd("Silver Obol of Construction", 3),
    pd("Silver Obol of Worship", 3),
    pd("Silver Obol of Little Damage", 2),
    pd("Gold STR Obol", 1.925),
    pd("Gold AGI Obol", 1.925),
    pd("Gold WIS Obol", 1.925),
    pd("Gold LUK Obol", 1.925),
    pd("Golden Obol of Cards", 0.3),
  ),

  d(
    "Weak UPG Stones",
    "YumYum Grotto",
    pd("Armor Upgrade Stone G", 4),
    pd("Weapon Upgrade Stone I", 18),
    pd("Helmet Upgrade Stone I", 14),
    pd("Armor Upgrade Stone I", 38),
    pd("Tool Upgrade Stone I", 26),
  ),

  d(
    "Level Up Gift Reward",
    "anywhere",
    pd("Birthday Hat", 0.03),
    pd("Gem", 31.97),
    pd("Small Experience Balloon", 4),
    pd("1 HR Time Candy", 3),
    pd("2 HR Time Candy", 1),
    pd("4 HR Time Candy", 0.3),
    pd("12 HR Time Candy", 0.05),
    pd("24 HR Time Candy", 0.02),
    pd("Fun Flags", 0.73),
    pd("Power Statue", 18.9),
    pd("Speed Statue", 18.9),
    pd("Mining Statue", 18.9),
    pd("Feasty Statue", 18.9),
    pd("Health Statue", 18.9),
    pd("Kachow Statue", 18.9),
    pd("Lumberbob Statue", 18.9),
    pd("Thicc Skin Statue", 18.9),
    pd("Sukka Foo", 0.5),
    pd("Mystery Upgrade Stone I", 1),
    pd("Small EXP Potion", 13.5),
    pd("Average EXP Potion", 13.5),
    pd("Decent EXP Potion", 13.5),
    pd("Card Stamp", 0.3),
    pd("Birthday Card", 24.7),

    pd("Pre Crime Box", NaN),
  ),
];
